import { useEffect, useRef } from 'react';



const UseInfiniteScroll = (getMoreContent:any, infiniteScrollFetchCondition: boolean) => {
    const infiniteScrollRef = useRef(null);

    useEffect(() => {
        if (getMoreContent) {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && infiniteScrollFetchCondition) {
                        getMoreContent();
                    }
                },
                {root: null, rootMargin: "20px", threshold: 1.0}
            );

            if (infiniteScrollRef.current) {
                observer.observe(infiniteScrollRef.current);
            }

            return () => {
                if (infiniteScrollRef.current) {
                    observer.unobserve(infiniteScrollRef.current);
                }
            };
        }
    }, [getMoreContent]);

    return infiniteScrollRef;
};

export default UseInfiniteScroll;